import React, { useEffect, useState } from 'react';
import { Button } from 'components';
import { updateFormField } from 'store/forms/actions';
import { useDispatch, useSelector } from 'react-redux';
import { FormField, RadioGroup, Tooltip } from 'components';
import { useForm } from 'antd/lib/form/Form';
import { omit, get, cloneDeep} from 'lodash';
import moment from 'moment';
import { isBeneficiary } from 'utils';
import { formFields1 } from './formFields';
import { Row, Form, Col } from 'antd';
import ConnectionDetails from './connectionDetails';
import { render } from '@testing-library/react';

const TechnicalCharacteristics = () => {
  const [form] = useForm();
  const dispatch = useDispatch();
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const carrier = useSelector(state => state.forms.carrier);
  const user = useSelector(state => state.user);
  const connectionDetails = useSelector(
    state => state.forms.carrier.connectionDetails
  ) || [
    {
      supplyNum: null,
      supAddress: null,
      storageCap: null,
      supplyPower: null,
    },
  ];

  const handleChangeConnections = ({ key, value }) => {
    dispatch(updateFormField({ group: 'carrier', key, value }));
  };

  useEffect(() => {
    var newValues = cloneDeep(connectionDetails);
    form.setFieldsValue({ connections: newValues });
  }, [carrier.connectionDetails]);

  const addMore = () => {
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'connectionDetails',
        value: [
          ...connectionDetails,
          {
            supplyNum: null,
            supAddress: null,
            storageCap: null,
            supplyPower: null,
          },
        ],
      })
    );
  };

  const removeConnection = key => {
    const value = connectionDetails.filter((_, index) => index !== key);
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'connectionDetails',
        value,
      })
    );
  };


  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals'
    ) {
      newValue = event;
    }

    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
  };

  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  const renderConnectionDetails = () =>
    connectionDetails.map((item, index) => (
      <ConnectionDetails
        item={item}
        key={index}
        index={index}
        disabled={viewMode || !isBeneficiary(user.groups)}
        removeConnection={removeConnection}
        update={({ key, value, index }) => {
          const newConnections = [...connectionDetails];
          newConnections[index] = {
            ...newConnections[index],
            [key]: value,
          };
          handleChangeConnections({
            key: 'connectionDetails',
            value: newConnections,
          });
        }}
        connections={connectionDetails}
      />
    ));

  return (
    <div className="">
    <Form
      form={form}
      initialValues={{
        ...carrier,
      }}
      trigger="onChange"
    >
      <div className="carrier-data-form">
        <p className="mt-0 mr-0 color-blue-3 text-bold font-size-24">
          Στοιχεία Φωτοβολταϊκού Σταθμού/Συστήματος Αποθήκευσης
        </p>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          className="carrier-data-form__row"
        >
          {formFields1.map((field, index) => {
            return (
              <Col key={index} className="gutter-row" span={field.span}>
                <Form.Item
                  name={[field.name]}
                  rules={field.rules}
                  value={renderFieldValue(field)}
                  validateFirst
                >
                  <FormField
                    key={index}
                    disabled={field?.disabled || viewMode}
                    {...omit(field, ['span', 'rules', 'offset', 'disabled'])}
                    onChange={value =>
                      handleChange({
                        key: field.name,
                        type: field.type,
                        event: value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
            );
          })}
        </Row>
      </div>
      <div className="carrier-data-form carrier-data-form__right">
        <p className="mt-0 mr-0 color-blue-3 text-bold font-size-24">
          Στοιχεία Σύνδεσης
        </p>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          // className="carrier-data-form__row"
        >
            <Col span={24}>{renderConnectionDetails()}</Col>
            {!viewMode && (
              <>
                <Col span={10}></Col>
                <Col span={14}>
                  <Button
                    className="mt-2 mr-0 addMoreBtn"
                    label={'Προσθήκη'}
                    onClick={addMore}
                  />
                </Col>
              </>
            )}
        </Row>
      </div>
    </Form>
  </div>
  );
};

export default TechnicalCharacteristics;
